import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

import config from "../config";
import LiveTrackingStore from "../store/LiveTrackingStore";



class MultiTrackingStore {
  multiTrackingArray = [];
  allVehicles = [];
  vehiclePosition = [];
  vehicleUpdatedPosition = [];
  vehicleLiveLatLongArray = [];
  vehiCleLiveLatLongObj = {};
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      multiTrackingArray: observable,
      allVehicles: observable,
      vehiclePosition: observable,
      vehicleUpdatedPosition: observable,
      vehicleLiveLatLongArray: observable,
      vehiCleLiveLatLongObj: observable,
      total: observable,
      loading: observable,
      loadData: action,
      getSelectedVehicles: action,
    });
    this.rootStore = rootStore;
    this.liveTrackingStore = new LiveTrackingStore(this);
  }

  async loadData({ offset, limit, companyId, warehouseId, poupSearch, isadmin, userCompanyId, userId, vehicleIds }) {
    this.loading = true;
    let newData
    let response

    if (config.project === 'proawtltrack') {
      response = await postApi
        .getClient("report")
        // .get("http://localhost:3015/liveTracking/getDatabyCH",{
        .get("/liveTracking/getDatabyCH", {
          params: {
            companyId: isadmin == 1 || 0 ? userCompanyId : companyId,
            userId: userId,
            isadmin: isadmin,
            status: "searchvod",
            poupSearch: poupSearch,
            offset: offset,
            limit: limit,
            selectedVehicleIds: vehicleIds?.join(','),
          },
        });
      newData = await this.liveTrackingStore.handleVehicleImageCH(
        response?.data?.data?.livetrack || []
      );
    } else {
      // const base64Input = await base64_encode(JSON.stringify(postData));
      // var response = await postApi
      //   .getClient()
      //   .post("index.php?c=vehicletracking&a=getdata", "postData=" + base64Input);
      response = await postApi
        .getClient()
        // .get("http://localhost:3053/liveTracking/getData", {
        .get(config.NodeUrl + "/liveTracking/getData", {
          params: {
            companyId: isadmin == 1 || 0 ? userCompanyId : companyId,
            offset: offset,
            limit: limit,
            poupSearch: poupSearch,
            selectedVehicleIds: vehicleIds?.join(','),
          }
        });
      newData = await this.liveTrackingStore.handleVehicleImage(
        response?.data?.data?.livetrack || []
      );
    }

    // this.multiTrackingArray =response?.data?.data?.livetrack
    //var multiTrackingArray = response?.data?.data?.livetrack;


    //  multiTrackingArray =  await this.liveTrackingStore.handleVehicleImage(multiTrackingArray);
    const map = new Map();

    // put existing vehicles
    this.allVehicles.forEach(v => {
      map.set(v.vehicleId, v);
    });

    // replace / add from new data
    newData.forEach(v => {
      map.set(v.vehicleId, {
        ...map.get(v.vehicleId),
        ...v
      });
    });

    // back to array
    this.allVehicles = Array.from(map.values());
    this.multiTrackingArray = newData;


    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }
  async getVehiclePosition({ vehicleId }) {
    var postData = { tokenId: "", vehicleId: vehicleId, refreshduration: 30 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=getvehicleposition",
        "postData=" + base64Input
      );
    // this.vehiclePosition = response
    // console.log(response.data.data.vehicleposition)
    let vehicle = [
      response.data.data.vehicleposition[0].latitude,
      response.data.data.vehicleposition[0].longitude,
    ];
    console.log(vehicle);
    this.vehicleUpdatedPosition.push(vehicle);
    console.log(this.vehicleUpdatedPosition, "updated");
    this.vehiclePosition = [
      [21, 21],
      [54, 21],
    ];
    return [
      response.data.data.vehicleposition[0].latitude,
      response.data.data.vehicleposition[0].longitude,
    ];
  }

  async getSelectedVehicles({ vehicleIds, selectedVehicles }) {


    await vehicleIds.forEach((vehicleId) => {
      let filterVehicle = this.allVehicles.find(
        // Force both to strings to ensure "123" matches 123
        (val) => String(val.vehicleId) === String(vehicleId)
      );

      if (filterVehicle) {
        // Process your filtered vehicle here
        console.log("Found match:", filterVehicle);
      } else {
        // Debugging: Log if not found to see why
        console.warn(`No match for ID: ${vehicleId}. Available IDs:`,
          this.multiTrackingArray.map(v => v.vehicleId)
        );
      }
      if (filterVehicle) {
        const { vehicleId, latitude, longitude, mapImage, formatted_address } =
          filterVehicle;
        if (!this.vehiCleLiveLatLongObj[vehicleId]) {
          this.vehiCleLiveLatLongObj[vehicleId] = {}; // Initialize an empty object for the vehicleId
          this.vehiCleLiveLatLongObj[vehicleId].liveLatLongArray = [
            [latitude, longitude],
          ];
          this.vehiCleLiveLatLongObj[vehicleId].mapImage = [mapImage];
          this.vehiCleLiveLatLongObj[vehicleId].formatted_address = [
            formatted_address,
          ];
        } else {
          // this.vehiCleLiveLatLongObj[vehicleId].liveLatLongArray.push([latitude, longitude]);
          this.vehiCleLiveLatLongObj[vehicleId].liveLatLongArray = [
            ...(this.vehiCleLiveLatLongObj[vehicleId].liveLatLongArray
              ? this.vehiCleLiveLatLongObj[vehicleId].liveLatLongArray
              : []),
            [latitude, longitude],
          ];
          this.vehiCleLiveLatLongObj[vehicleId].mapImage.push([mapImage]);
          this.vehiCleLiveLatLongObj[vehicleId].formatted_address.push([
            formatted_address,
          ]);
        }
      }
    });

    this.vehicleLiveLatLongArray = selectedVehicles;
  }
}

export default MultiTrackingStore;

//console.log(multiTrackingArray)

// console.log(multiTrackingArray, "multitrackingArray");
// Object.keys(multiTrackingArray).map((e, i) => {
//   let r = multiTrackingArray[i];

//   // var diff = new Date(r.currtime) - new Date(r.updatedate);
//   const diff = moment(r.currtime).diff(r.updatedate, "minutes");

//   var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");

//   const acc = parseInt(r.acc);
//   const speed = parseInt(r.speed);
//   // console.log(r, diff, vehicleTypeNew);
//   // console.log(differenceInHours)

//   if (diff >= 90) {
//     multiTrackingArray[i].listImage = vehicleTypeNew + "-gray.png";
//     multiTrackingArray[i].rowBackground = "gray";
//     multiTrackingArray[i].currentStatus = "nodata";
//   } else if (acc == 1 && speed == 0) {
//     //idle)
//     multiTrackingArray[i].listImage = vehicleTypeNew + "-yellow.png";
//     multiTrackingArray[i].rowBackground = "yellow";
//     multiTrackingArray[i].currentStatus = "idle";
//   } else if (acc == 0) {
//     multiTrackingArray[i].listImage = vehicleTypeNew + "-red.png";
//     multiTrackingArray[i].rowBackground = "red";
//     multiTrackingArray[i].currentStatus = "stop";
//   } else if (acc == 1 && speed > 0) {
//     // console.log(multiTrackingArray[i]);
//     multiTrackingArray[i].listImage = vehicleTypeNew + "-green.png";
//     multiTrackingArray[i].rowBackground = "green";
//     multiTrackingArray[i].currentStatus = "running";
//   }
//   multiTrackingArray[i].mapImage = multiTrackingArray[i].listImage;

//   try {
//     require("../assets/images/detailtracking/" +
//       multiTrackingArray[i].listImage);
//   } catch (err) {
//     multiTrackingArray[i].listImage = "car-icon-blue.png";
//   }

//   try {
//     require("../assets/images/livetracking/" +
//       multiTrackingArray[i].mapImage);
//   } catch (err) {
//     multiTrackingArray[i].mapImage = "car-icon-blue.png";
//   }
// });

//console.log(multiTrackingArray);
//  this.totalvehstate = response?.data?.data?.totalvehstate;
